// import useSwitchLanguageTravelSearchForm from "zorni_search/useSwitchLanguageTravelSearchForm";
// import useSwitchLanguageTravelDetails from "zorni_travel_details/useSwitchLanguageTravelDetails";
// import useSwitchLanguageSearchResult from "zorni_travel_search_result/useSwitchLanguageSearchResult";
// import useSwitchLanguageAdministration from "zorni_administration/useSwitchLanguageAdministration";
import i18n from "../../i18n";
import useSwitchLanguageProfil from "./useSwitchLanguageProfil";

const useSwitchAllLanguages = () => {
  // const switchLanguageHookTravelSearchForm =
  //   useSwitchLanguageTravelSearchForm();
  // const switchLanguageSearchResult = useSwitchLanguageSearchResult();

  // const switchLanguageHookSearchForm = useSwitchLanguageTravelSearchForm();
  // const switchLanguageHookDetails = useSwitchLanguageTravelDetails();
  const switchLanguageProfil = useSwitchLanguageProfil();

  // const switchLanguageAdministration = useSwitchLanguageAdministration();

  // const switchLanguageSearchForm = (languageCode) =>
  //   switchLanguageHookSearchForm(languageCode);

  // const switchLanguageDetails = (languageCode) =>
  //   switchLanguageHookDetails(languageCode);

  // const switchLanguage = (languageCode) => {
  //   i18n.changeLanguage(languageCode);
  //   switchTravelSearchFormLanguageHook(languageCode);
  //   switchLanguageSearchResult(languageCode);
  //   switchLanguageProfil(languageCode);
  // };

  const switchAllLanguages = (languageCode) => {
    // switchLanguageSearchForm(languageCode);
    // switchLanguageDetails(languageCode);
    switchLanguageProfil(languageCode);
    // switchLanguageSearchResult(languageCode);
    // switchLanguageHookTravelSearchForm(languageCode);
    // switchLanguageAdministration(languageCode);
  };

  return {
    switchAllLanguages,
  };
};

export default useSwitchAllLanguages;
